// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import router from "./router"

import i18n from "./locale/index"
import store from "./store"
import axios from "axios"
import "@/assets/fonts/iconfont.css"
import "@/styles/index.css"

import Vant, { Locale, Toast } from "vant"
import enUS from "vant/es/locale/lang/en-US"
import "vant/lib/index.css"
Locale.use("en-US", enUS)
Vue.use(Vant, Toast)

import ElementUI from "element-ui"
import locale from "element-ui/lib/locale/lang/en"
import "element-ui/lib/theme-chalk/index.css"
Vue.use(ElementUI, { size: "small", locale, zIndex: 5000 })

import * as echarts from "echarts"
Vue.prototype.$echarts = echarts

import "@/assets/fonts/iconfont.css"
import "@/styles/index.css"
import animate from "animate.css"
Vue.use(animate)

import dayjs from "dayjs"
Vue.prototype.$dayjs = dayjs

Vue.config.productionTip = false
Vue.prototype.$axios = axios

import { debounce } from "lodash"
Vue.prototype.$debounce = debounce

import * as filters from "./utils/filters"
Vue.prototype.$$ = filters.optionalChaining
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

window.addEventListener("resize", () => {
  store.dispatch("app/initWindowListener")
})

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>"
})



// WEBPACK FOOTER //
// ./src/main.js